<template>
    <div class="row pt-3" v-for="(entry, key) in localValue" :key="key">
      <div class="col">
        <div class="form-floating">
          <form-field
            :element="propertyElements[property] ?? 'Form/TextInput.vue'"
            :name="name + '.' + key"
            :label="label + ` (${key})`"
            :property-elements="propertyElements"
            :value="entry ?? ''"
            @update:data="(updatedValue) => updateData(updatedValue, key)"
          />
        </div>
      </div>
    </div>
    <div class="d-flex row pt-2">
      <div class="col-10 pe-0">
        <div class="form-floating">
          <form-field
            :element="propertyElements[property] ?? 'Form/TextInput.vue'"
            :label="'Neuer Eintrag in ' + label"
            :name="'newValue'"
            :value="newValue"
            @update:data="(data) => newValue = data"
          />
        </div>
      </div>
      <div class="col-2 flex-0 px-0">
        <div class="form-floating">
          <button type="button" @click="addValue()">+</button>
        </div>
      </div>
    </div>
  </template>

  <script>
  import FormField from '@kanrisha/components/Form/FormField';
  import { ref } from 'vue';

  export default {
    components: {
      FormField,
    },
    props: {
      label: { type: String, default: '' },
      propertyElements: { type: Object, default: () => ({}) },
      name: { type: String, default: '' },
      value: { type: Array, default: () => [] },
    },
    emits: ['update:data'],
    setup(props, { emit }) {
      const localValue = ref(props.value ?? []);
      const newValue = ref('');

      const updateData = (val, key) => {
        localValue.value[key] = val;
        emit('update:data', localValue.value);
      };

      const addValue = () => {
        if (newValue.value) {
          localValue.value.push(newValue.value);
          emit('update:data', localValue.value);
          newValue.value = ''; // Clear the input field after saving
        }
      };

      return {
        addValue,
        localValue,
        newValue,
        updateData,
      };
    },
  };
  </script>
